@import ../../styles/helpers

.form
    &__column
        height: 100%
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        gap: 20px
    &__title
        font-size: 40px
        font-weight: 500px !important
        text-align: center
    &__btn
        display: flex
        gap: 20px
        div
            display: flex
            gap: 20px
    &__inputbox
        display: flex
        flex-direction: column
        justify-content: space-around
        width: 75%
        gap: 20px
        +m
            width: 100%
    &__inputsass
        width: 100%
        height: 48px
        padding: 0 14px 0 14px
        border-radius: 12px
        background: none
        border: 2px solid $neutrals6
        +snappy
        color: $neutrals2
        transition: border-color .2s
        +dark
            border-color: $neutrals3
            color: $neutrals8
        +placeholder
            color: $neutrals4
        &:focus
            border-color: $neutrals4
